import layout from '@/views/common/layout'
const warehouseRoute = [
    {
        path: '/warehouse',
        component: layout,
        children: [
            {
              path: 'warehouseList',
              component: () => import('@/views/warehouse/warehouseList'),
              name: 'warehouseList',
              meta: { title: '仓库管理', icon: '', affix: true }
            },
            {
              path: 'warehouseDetail',
              component: () => import('@/views/warehouse/warehouseDetail'),
              name: 'warehouseDetail',
              meta: { title: '仓库详情', icon: '', affix: true },
          },
        ]
    }
]

export default warehouseRoute


// WEBPACK FOOTER //
// ./src/router/modules/warehouse.js